import request from '../utils/request'

export function selectCategoryList(data) {
  return request({
    url: '/api/category/list',
    method: 'post',
    data,
  })
}
